import * as React from "react";
import { apiErrorMessage } from "../screens/common";

// 보호자/어르신이 완료된 방문에 담당 매니저 별점(+한줄평)을 남기는 모달.
// POST /api/v1/manager_ratings { visit_id, stars, comment }. 제출 성공 시
// onSubmitted(stars)로 부모가 목록을 즉시 갱신한다.
export function RatingModal({ visit, onClose, onSubmitted }) {
  const [stars, setStars] = React.useState(visit.my_rating || 0);
  const [comment, setComment] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const [err, setErr] = React.useState(null);

  const submit = async () => {
    if (!stars) { setErr("별점을 선택해주세요."); return; }
    setBusy(true); setErr(null);
    try {
      const r = await fetch("/api/v1/manager_ratings", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ visit_id: visit.id, stars, comment }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) { setErr(apiErrorMessage(j, r.status)); return; }
      onSubmitted(stars);
    } catch (e) { setErr(apiErrorMessage(e)); } finally { setBusy(false); }
  };

  return (
    <div onClick={onClose}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
               display: "grid", placeItems: "end center", zIndex: 200 }}>
      <div onClick={(e) => e.stopPropagation()} className="card"
        style={{ width: "100%", maxWidth: 480, borderRadius: "18px 18px 0 0", padding: "22px 22px 28px" }}>
        <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 4 }}>
          {visit.manager_name} 매니저 평가
        </div>
        <div className="muted" style={{ fontSize: 11.5, marginBottom: 16 }}>
          방문은 어떠셨나요? 별점을 남겨주세요.
        </div>
        <div style={{ display: "flex", justifyContent: "center", gap: 8, marginBottom: 18 }}>
          {[1, 2, 3, 4, 5].map((n) => (
            <button key={n} type="button" aria-label={`${n}점`} onClick={() => setStars(n)}
              style={{ background: "none", border: "none", fontSize: 38, lineHeight: 1, cursor: "pointer",
                       color: n <= stars ? "var(--amber-500)" : "var(--border)" }}>★</button>
          ))}
        </div>
        <textarea className="input" rows={3} placeholder="한줄평 (선택)" value={comment}
          onChange={(e) => setComment(e.target.value)} style={{ marginBottom: 12, resize: "none" }} />
        {err && <div style={{ color: "var(--rose-500)", fontSize: 12, marginBottom: 10 }}>{err}</div>}
        <div style={{ display: "flex", gap: 8 }}>
          <button type="button" className="btn btn-ghost btn-lg" onClick={onClose} style={{ flex: 1 }}>취소</button>
          <button type="button" className="btn btn-primary btn-lg" onClick={submit} disabled={busy} style={{ flex: 2 }}>
            {busy ? "제출 중…" : "평가 제출"}
          </button>
        </div>
      </div>
    </div>
  );
}
